export default {
    title: "Tehnomax",
    storeOverview: "Pregled prodavnice",
    welcomeMessage: "Dobro došli u Vašu prodavnicu.",
    verification: "Vaša prodavnica trenutno prolazi proces verifikacije. Naš admin tim provjerava podatke i uskoro ćete biti obavješteni da li je Vaša prodavnica uspješno verifikovana.",
    afterVerification: "Nakon uspješne verifikacije Vaša prodavnica će dobiti verifikovani status.",
    notVerified: "Ukoliko imate kompaniju dobićete poseban status na platformi. Da biste unijeli podatke za kompaniju kliknite ",
    here: "ovdje",
    isVerified: "Prodavnica je verifikovana",
    orders: {
        title: "Narudžbine",
        viewLink: "Pogledaj",
        newOrders: "Nove narudžbine",
        openOrders: "Otvorene narudžbine",
    },
    statistics: {
        title: "Statistika",
        totalVisits: "Ukupan broj posjeta",
        totalPurchases: "Ukupan broj kupovina",
        averageGrade: "Prosječna ocjena"
    },
    incomeOverview: {
        title: "Pregled prihoda",
        totalIncome: "Ukupan prihod"
    },
    income: {
        title: "Prihodi",
        date: "Izaberi datum",
        thisYear: "Ova godina",
        lastMonth: "Ovaj mjesec",
        lastWeek: "Prošla sedmica",
        lastThreeDays: "Zadnja tri dana",
        custom: "Proizvoljno"
    },
    rolesUsers: {
        title: "Uloge i korisnici",
        viewLink: "Pogledaj",
        online: "Online",
        offline: "Offline"
    },
    ordersByCity: {
        title: "Narudžbine po gradovima"
    },
    popularProducts: {
        title: "Najpopularniji proizvodi"
    },
    pagination: {
        showing: "Prikazano",
        outOf: "od",
        people: "ljudi"
    },
    days: {
        monday: "Ponedjeljak",
        tuesday: "Utorak",
        wednesday: "Srijeda",
        thursday: "Četvrtak",
        friday: "Petak",
        saturday: "Subota",
        sunday: "Nedjelja",
    },
    months: {
        january: "Januar",
        february: "Februar",
        march: "Mart",
        april: "April",
        may: "Maj",
        june: "Jun",
        july: "Jul",
        august: "Avgust",
        september: "Septembar",
        october: "Oktobar",
        november: "Novembar",
        december: "Decembar"
    }
}
